import { render, staticRenderFns } from "./Monitorings.vue?vue&type=template&id=5428dfdd"
import script from "./Monitorings.vue?vue&type=script&lang=js"
export * from "./Monitorings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports